import React from 'react';
import { OverviewSubjectSummary } from '../../pages/Data/partials';
import styles from './styles.css';
import { getLocationType, isACountry } from '../../actions';
import LocationName from '../LocationName/index.jsx';
import { useTranslation } from 'react-i18next';

export default function OverviewSingleLocationMultiSubject({ locationData }) {
	const { t } = useTranslation();
	const locationUrl = `${window.location.origin}/locations/${locationData.iso.toLowerCase()}.html`; // eslint-disable-line i18next/no-literal-string
	const viewMoreCountryInfoLink =
		isACountry(locationData.iso) && !locationData.isTakingScreenshot
			? `/locations/${locationData.iso.toLowerCase()}.html?meas=GOVERNANCE&loc=${locationData.iso}`
			: null;
	return (
		<div className={`${styles.wrapper} overview-main uk-text-center overview-white overview-multi-measure`}>
			<div className="overview-country">
				<a
					href={locationUrl}
					className="overview_headline uk-margin-top uk-margin-large-bottom"
					style={{ textDecoration: 'none', color: 'inherit' }}
				>
					<h1 className="overview-title">
						<LocationName type={getLocationType(locationData.iso)}>{locationData.headline}</LocationName>
						<img
							src={`img/flags/${locationData.iso.toLowerCase()}.svg`}
							className={`flag-image flag ${locationData.hideFlag} ${styles.flagIcon} measure-icon-image`}
						/>
					</h1>
				</a>
			</div>

			<div className="overview-multi-measure-measure-wrapper" id="pnl_sub_overview">
				{locationData.subjects.map((e) => (
					<OverviewSubjectSummary
						key={`${locationData.iso}-${e}`}
						location={locationData.iso}
						subject={e}
						numSubjects={locationData.subjects.length}
						overviewStateAT={locationData.overviewStateAT}
					/>
				))}
			</div>
			{viewMoreCountryInfoLink ? (
				<div className="overview-button-wrapper">
					<a
						href={viewMoreCountryInfoLink}
						id="view_more_country_info_link"
						className="uk-button uk-button-outline uk-border-rounded mif-orange-outline-button uk-text-uppercase"
					>
						{t('VIEW MORE COUNTRY INFO')}
					</a>
				</div>
			) : null}
		</div>
	);
}
